(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["ave-home-hero"] && !Shopify.designMode) return;
  try {
    
(() => {
  const init = (root = document) => {
    root.querySelectorAll('[data-clic-hero]').forEach(hero => {
      if (hero.dataset.ready) return;
      hero.dataset.ready = 'true';
      const video = hero.querySelector('video');
      const button = hero.querySelector('button');
      const reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
      const sync = () => { button.setAttribute('aria-label', video.paused ? button.dataset.play : button.dataset.pause); button.dataset.paused = String(video.paused); button.textContent = ''; };
      button.hidden = false;
      video.addEventListener('play', sync);
      video.addEventListener('pause', sync);
      button.addEventListener('click', () => { if(video.paused) video.play().catch(sync); else video.pause(); });
      reduced.addEventListener('change', () => { if(reduced.matches) video.pause(); });
      if (!reduced.matches && !navigator.connection?.saveData) video.play().catch(sync);
      sync();
    });
  };
  if(document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init()); else init();
  document.addEventListener('shopify:section:load', event => init(event.target));
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["build-your-bag"] && !Shopify.designMode) return;
  try {
    
  class BuildYourBag extends HTMLElement {
    connectedCallback() {
      this.categories = {
        putting:['Putting Putter','Controlled putts and short, touch-oriented throws near the basket.','Putting|Short approaches|Straight touch shots|Low-speed control','Choose a putter that feels comfortable for a repeatable release. Union is the current Avenue putter.','Union','Shortest distance · highest touch control · deep, blunt rim'],
        throwing:['Throwing Putter','Accurate, controlled drives and approaches when placement matters more than raw distance.','Short tee shots|Straight approaches|Controlled tunnel shots|Learning clean release angles','A throwing putter rewards a smooth release and shows you what your throw is doing.','Union','Short distance · very high control · putter-width rim'],
        approach:['Approach Disc','Reliable placement on shorter shots when a predictable finish or controlled ground action matters. The distinction from a throwing putter is partly conventional and may overlap.','Short forehand approaches|Windier approaches|Controlled fades|Landing near the basket','Approach discs are built to make short placement shots repeatable.','Coming Soon','Short distance · high control · low-profile rim'],
        midrange:['Midrange','Versatile control through the middle portion of the course.','Straight fairway shots|Controlled drives|Wooded lines|Moderate-distance approaches','A midrange provides more reach than a putter without giving up slower-disc control.','Alley','Moderate distance · high control · medium rim'],
        fairway:['Fairway Driver','Controlled distance with a more manageable rim and flight than a high-speed distance driver.','Longer controlled tee shots|Narrow fairways|Shaped lines|Exploring driver distance','A fairway driver adds distance while keeping placement at the center of the shot.','Arcade','Longer distance · balanced control · moderate driver rim'],
        control:['Control or Hybrid Driver','A market-convention category bridging fairway control and distance-driver potential.','Longer controlled drives|Wind-resistant placement|Predictable line shaping','This category adds speed while still keeping control within reach.','Coming Soon','Long distance · moderate control · wider driver rim'],
        distance:['Distance Driver','Maximum-distance design for players who can supply enough release speed, spin, space, and control.','Long open tee shots|Maximum-distance attempts|Advanced shaping','A faster disc only travels farther when the throw gives it what it needs.','Coming Soon','Longest potential distance · lower margin for error · widest rim']
      };
      this.panel=this.querySelector('#BagCategoryPanel');
      this.querySelectorAll('[data-category]').forEach(button=>button.addEventListener('click',()=>this.selectCategory(button)));
      this.querySelectorAll('[data-shot]').forEach(button=>button.addEventListener('click',()=>this.selectShot(button)));
      this.querySelectorAll('[data-build-bag-variant]').forEach(select=>select.addEventListener('change',()=>{select.closest('form').querySelector('[data-build-bag-variant-id]').value=select.value;}));
      const first=this.querySelector('[data-category]'); if(first) this.selectCategory(first);
    }
    selectCategory(button){this.querySelectorAll('[data-category]').forEach(item=>item.setAttribute('aria-selected',String(item===button))); const data=this.categories[button.dataset.category]; this.panel.innerHTML=`<p class="build-bag__eyebrow">${data[4]}</p><h3>${data[0]}</h3><p>${data[1]}</p><p><strong>Useful for:</strong> ${data[2].split('|').join(' · ')}</p><p><strong>Distance / control / rim:</strong> ${data[5]}</p><p><strong>Beginner takeaway:</strong> ${data[3]}</p>`;}
    selectShot(button){this.querySelectorAll('[data-shot]').forEach(item=>item.setAttribute('aria-pressed',String(item===button))); const routes={putt:'Union — the current Avenue putter for putting, short throws, and approaches. Choose the feel that gives you a comfortable, repeatable release.',short:'Union — a throwing putter for accurate placement on shorter tee shots.',approach:'Throwing Putter or Approach Disc. Union covers the current controlled-approach role; a dedicated Approach Disc is Coming Soon.',shape:'Alley or Arcade — choose Alley for midrange control or Arcade when the shot asks for fairway-driver distance.',control:'Arcade — the current Avenue route for controlled driver distance.',maximum:'Distance Driver — Coming Soon. Build line control with Arcade in the meantime.',wind:'Approach, Control, or Distance categories may help depending on the throw. Those Avenue categories are Coming Soon; do not treat another mold as an exact substitute.',form:'Union or Alley — slower categories make release angles and wobble easier to observe.'}; this.querySelector('.build-bag__shot-result').textContent=routes[button.dataset.shot];}
  }
  if(!customElements.get('build-your-bag')) customElements.define('build-your-bag',BuildYourBag);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["find-your-disc"] && !Shopify.designMode) return;
  try {
    
  class FindYourDisc extends HTMLElement {
    connectedCallback() {
      this.form = this.querySelector('form');
      this.result = this.querySelector('.find-disc__result');
      if (!this.form || !this.result) return;
      this.form.addEventListener('change', () => this.updateResult());
    }

    updateResult() {
      const answered = new Set(new FormData(this.form).keys()).size;
      if (answered === 4) this.result.hidden = false;
    }
  }

  if (!customElements.get('find-your-disc')) customElements.define('find-your-disc', FindYourDisc);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
